import { render, staticRenderFns } from "./AccountBlock.vue?vue&type=template&id=20ee073a&scoped=true"
import script from "./AccountBlock.vue?vue&type=script&lang=js"
export * from "./AccountBlock.vue?vue&type=script&lang=js"
import style0 from "./AccountBlock.vue?vue&type=style&index=0&id=20ee073a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee073a",
  null
  
)

export default component.exports